const Calendar = (props) => (
  <svg width='25.5' height='25.5' viewBox='0 0 25.5 25.5' fill='#a5a8b9' {...props}>
    <path d='M21.25,1.428V0H18.428V1.428H7.072V0H4.25V1.428H0V25.5H25.5V1.428ZM2.822,22.678V8.5H22.678V22.678Z' />
  </svg>
)

export default Calendar
